module.exports = __webpack_public_path__ + "static/media/meditate4.882993ce.jpg";